module.exports = __webpack_public_path__ + "img/radio-active.03120ad2.svg";